function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#000000",
    d: "M -0.5,261.5 C -0.5,257.5 -0.5,253.5 -0.5,249.5C 37.5393,185.967 90.8726,140.134 159.5,112C 215.446,92.6535 272.113,90.3202 329.5,105C 342.727,108.853 355.561,113.686 368,119.5C 385.833,101.667 403.667,83.8333 421.5,66C 428.167,62.6667 434.833,62.6667 441.5,66C 448.069,72.9446 449.236,80.7779 445,89.5C 326.5,208 208,326.5 89.5,445C 71.1328,451.294 62.6328,444.794 64,425.5C 64.6667,424.167 65.3333,422.833 66,421.5C 81.3474,406.319 96.5141,390.986 111.5,375.5C 65.0233,346.358 27.6899,308.358 -0.5,261.5 Z M 254.5,127.5 C 284.928,127.886 314.261,133.719 342.5,145C 332,155.5 321.5,166 311,176.5C 281.194,157.448 249.694,154.281 216.5,167C 174.623,188.24 155.789,222.407 160,269.5C 162.372,284.624 167.872,298.457 176.5,311C 163.5,324 150.5,337 137.5,350C 95.8277,327.175 61.8277,295.675 35.5,255.5C 65.7276,209.099 105.728,173.932 155.5,150C 187.109,135.782 220.109,128.282 254.5,127.5 Z M 254.5,191.5 C 265.968,191.934 276.635,195.1 286.5,201C 258,229.5 229.5,258 201,286.5C 192.548,271.822 190.215,256.156 194,239.5C 201.167,216.333 216.333,201.167 239.5,194C 244.643,193.162 249.643,192.328 254.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#000000",
    d: "M 511.5,249.5 C 511.5,253.5 511.5,257.5 511.5,261.5C 469.934,331.219 410.6,379.053 333.5,405C 280.778,419.123 228.111,418.956 175.5,404.5C 175.351,403.448 175.517,402.448 176,401.5C 184.375,392.79 193.042,384.457 202,376.5C 273.439,391.679 338.939,378.179 398.5,336C 428.813,313.523 454.479,286.689 475.5,255.5C 455.163,225.327 430.496,199.161 401.5,177C 408.456,169.042 415.789,161.376 423.5,154C 424.5,153.333 425.5,153.333 426.5,154C 460.779,180.766 489.113,212.599 511.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#000000",
    d: "M 346.5,230.5 C 357.783,269.209 348.116,302.376 317.5,330C 291.932,349.89 263.265,356.223 231.5,349C 230.549,348.282 230.383,347.449 231,346.5C 240.167,337.333 249.333,328.167 258.5,319C 294,314.167 314.167,294 319,258.5C 328.369,249.298 337.536,239.965 346.5,230.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/HidePasswordIcon.e6fa43e8.svg";
export { ForwardRef as ReactComponent };